import React, { FC } from "react";
import { Checkbox, IconToggle } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { AttributesBlockCheckbox, ToggleVisibilityLabel } from "./styled";

import { AttributesProps } from "./Attributes";

type AttributesVisibilityHeaderProps = Pick<
  AttributesProps,
  "allAttributes" | "allAttributesLabel" | "toggleAllAttributes" | "className" | "isEdit"
>;

export const AttributesVisibilityHeader: FC<AttributesVisibilityHeaderProps> = ({
  allAttributes,
  allAttributesLabel,
  toggleAllAttributes,
  isEdit,
  className,
}) => {
  const { t } = useTranslation("dialogs");

  return (
    <AttributesBlockCheckbox className={className}>
      {isEdit ? (
        <IconToggle
          onClick={toggleAllAttributes}
          isSelected={allAttributes}
          kind={allAttributes ? "password_show" : "password_hide"}
          title={
            allAttributes
              ? t("editResource.attributeOff", { ns: "dialogs" })
              : t("editResource.attributeOn", { ns: "dialogs" })
          }
        >
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <ToggleVisibilityLabel>{t("editResource.allAttributes")}</ToggleVisibilityLabel>
        </IconToggle>
      ) : (
        <Checkbox
          label={allAttributesLabel || t("editResource.allAttributes")}
          checked={allAttributes}
          onChange={toggleAllAttributes}
        />
      )}
    </AttributesBlockCheckbox>
  );
};
